import React, { createContext, useContext, useState } from 'react';

// 🔹 Typ für den Formular-Zustand exportieren
export interface FormState {
    jobID: string;
    AusfuehrungszeitStart: string; // Neu: Startdatum und Uhrzeit
    AusfuehrungszeitEnde: string;  // Neu: Enddatum und Uhrzeit
    customerID: string;
    firma: string;
    strasse: string;
    hausnummer: string;
    plz: string;
    ort: string;
    titel: string;
    vorname: string;
    nachname: string;
    email: string;
    EinsatzPLZ?: string;
    EinsatzORT?: string;
    EinsatzStrasse?: string;
    EinsatzHausnummer?: string;
}

// 🔹 Initialwerte für leeres Formular
const initialFormState: FormState = {
    jobID: '',
    AusfuehrungszeitStart: '', // Initial leerer String für ISO-Format
    AusfuehrungszeitEnde: '',  // Initial leerer String für ISO-Format
    customerID: '',
    firma: '',
    strasse: '',
    hausnummer: '',
    plz: '',
    ort: '',
    titel: '',
    vorname: '',
    nachname: '',
    email: ''
};

// 🔹 Context erstellen
const FormContext = createContext<{
    formData: FormState;
    setFormData: React.Dispatch<React.SetStateAction<FormState>>;
}>({
    formData: initialFormState,
    setFormData: () => {}
});

// 🔹 Provider-Wrapper für App
export const FormProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [formData, setFormData] = useState<FormState>(initialFormState);
    
    return (
        <FormContext.Provider value={{ formData, setFormData }}>
            {children}
        </FormContext.Provider>
    );
};

// 🔹 Custom Hook für einfachen Zugriff
export const useForm = () => useContext(FormContext);